import * as React from 'react';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { Location } from 'history';
import { NavLinkListItem } from './NavLinkListItem';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@material-ui/icons/Search';
import ShareIcon from '@material-ui/icons/Share';
import { IOrganization } from '@pec/aion-ui-core/interfaces/organization';
import { isComplianceRegionUS } from '@pec/aion-ui-core/helpers/complianceRegion';

type Props = {
  location: Location;
  organization: IOrganization;
};

const Icon = (isUSComplianceRegion: boolean) => {
  return isUSComplianceRegion ? <ShareIcon /> : <SearchIcon />;
};

const Text = (isUSComplianceRegion: boolean, t: any) => {
  return isUSComplianceRegion
    ? t('components.connect', 'Connect')
    : t('components.searchAndConnect', 'Search and Connect');
};

export const Connect: React.FC<Props> = ({ organization }) => {
  const { id, features } = organization;
  const { t } = useTranslation('connect');
  const iconElement = Icon(isComplianceRegionUS(features));
  const textElement = Text(isComplianceRegionUS(features), t);

  return process.env.REACT_APP_NAME === AppName.AionConnectUI ? (
    <NavLinkListItem divider icon={iconElement} to={`/organizations/${id}/connect`}>
      {textElement}
    </NavLinkListItem>
  ) : (
    <AnchorListItem divider icon={iconElement} href={`/organizations/${id}/connect`}>
      {textElement}
    </AnchorListItem>
  );
};
